import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
  actions: {
    paddingTop: 36,
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    gap: 16,
    '@media (max-width: 767px)': {
      paddingTop: 4,
    },
    '@media (max-width: 570px)': {
      flexDirection: "column"
    },
    '& button': {
      width: "100%",
    }
  }
});
